<div>
    @if (metricsLoadError) {
        <div class="alert alert-warning py-2 small" role="alert">Dashboard metrics could not be loaded. Try refreshing the page.</div>
    }

    <div class="row g-3 mb-3">
        <div class="col-6 col-lg-3">
            <div class="card h-100 border-primary border-opacity-25">
                <div class="card-body py-3">
                    <div class="text-muted small text-uppercase">Total uploads</div>
                    <div class="fs-3 fw-semibold">{{ metrics.totalUploads }}</div>
                </div>
            </div>
        </div>
        <div class="col-6 col-lg-3">
            <div class="card h-100 border-info border-opacity-50">
                <div class="card-body py-3">
                    <div class="text-muted small text-uppercase">In progress</div>
                    <div class="fs-3 fw-semibold">{{ metrics.inProgress }}</div>
                </div>
            </div>
        </div>
        <div class="col-6 col-lg-3">
            <div class="card h-100 border-success border-opacity-25">
                <div class="card-body py-3">
                    <div class="text-muted small text-uppercase">Ready to accept in Vista</div>
                    <div class="fs-3 fw-semibold">{{ metrics.readyToAcceptInVista }}</div>
                </div>
            </div>
        </div>
        <div class="col-6 col-lg-3">
            <div class="card h-100 border-danger border-opacity-50">
                <div class="card-body py-3">
                    <div class="text-muted small text-uppercase">Failed</div>
                    <div class="fs-3 fw-semibold">{{ metrics.failed }}</div>
                </div>
            </div>
        </div>
    </div>

    <div class="row g-3 mb-3">
        <div class="col-6 col-lg-3">
            <div class="card h-100">
                <div class="card-body py-3">
                    <div class="text-muted small text-uppercase">Succeeded</div>
                    <div class="fs-4 fw-semibold">{{ metrics.succeeded }}</div>
                </div>
            </div>
        </div>
        <div class="col-6 col-lg-3">
            <div class="card h-100">
                <div class="card-body py-3">
                    <div class="text-muted small text-uppercase">Timed out</div>
                    <div class="fs-4 fw-semibold">{{ metrics.timedOut }}</div>
                </div>
            </div>
        </div>
        <div class="col-6 col-lg-3">
            <div class="card h-100">
                <div class="card-body py-3">
                    <div class="text-muted small text-uppercase">Last 30 days</div>
                    <div class="fs-4 fw-semibold">{{ metrics.last30DaysCount }}</div>
                </div>
            </div>
        </div>
    </div>

    <div class="row g-3">
        <div class="col-lg-6">
            <div class="card h-100">
                <div class="card-body">
                    <h5 class="card-title">Uploads by file type</h5>
                    @if (metrics.byRecordType.length === 0) {
                        <p class="text-muted small mb-0">No uploads yet.</p>
                    } @else {
                        <table class="table table-sm table-hover mb-0">
                            <thead>
                                <tr>
                                    <th>File type</th>
                                    <th class="text-end">Count</th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (row of metrics.byRecordType; track row.label) {
                                    <tr>
                                        <td>{{ row.label }}</td>
                                        <td class="text-end fw-semibold">{{ row.count }}</td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    }
                </div>
            </div>
        </div>

        <div class="col-lg-6">
            <div class="card h-100">
                <div class="card-body">
                    <h5 class="card-title">Uploads by status</h5>
                    @if (metrics.byStatus.length === 0) {
                        <p class="text-muted small mb-0">No uploads yet.</p>
                    } @else {
                        <table class="table table-sm table-hover mb-0">
                            <thead>
                                <tr>
                                    <th>Status</th>
                                    <th class="text-end">Count</th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (row of metrics.byStatus; track row.label) {
                                    <tr>
                                        <td>{{ row.label }}</td>
                                        <td class="text-end fw-semibold">{{ row.count }}</td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    }
                </div>
            </div>
        </div>
    </div>
</div>
